import SuggestionPanelComponent, { SUGGESTION_PANEL_BASE_HTML_CLASS } from "./suggestion_panel_component";

// PasswordPanel — the address has a password account (the ONE enumeration disclosure). Enter
// it to sign in, then the host POSTs the suggestion. Forgot routes on to the reset panel;
// Skip submits anonymously with no password; Back returns to the identity step.
export class PasswordPanel extends SuggestionPanelComponent {
  static get config() {
    return {
      componentTypeKey: "SuggestionPasswordPanel",
      baseHtmlClass: SUGGESTION_PANEL_BASE_HTML_CLASS,
      selector: ".suggestion_panel__panel--password",
      phase: "password",

      passwordInputSelector: "input[type='password']",
      forgotSelector: ".suggestion_panel__forgot",
      skipSelector: ".suggestion_panel__skip",
      backSelector: ".suggestion_panel__back",
      statusSelector: ".suggestion_panel__status",
    };
  }

  constructor(id_or_element, host) {
    super(id_or_element, host, PasswordPanel.config);
    const config = PasswordPanel.config;

    this.passwordInput = this.element.querySelector(config.passwordInputSelector);
    this.statusEl = this.element.querySelector(config.statusSelector);

    this.element.addEventListener("submit", (event) => {
      if (event) event.preventDefault();
      this.host.submitPassword(this.passwordInput ? this.passwordInput.value : "");
    });

    const forgot = this.element.querySelector(config.forgotSelector);
    if (forgot) forgot.addEventListener("click", (event) => {
      if (event) event.preventDefault();
      this.host.openForgot();
    });

    const skip = this.element.querySelector(config.skipSelector);
    if (skip) skip.addEventListener("click", (event) => {
      if (event) event.preventDefault();
      this.host.skipAuth();
    });

    const back = this.element.querySelector(config.backSelector);
    if (back) back.addEventListener("click", (event) => {
      if (event) event.preventDefault();
      this.host.changeEmail();
    });
  }

  render() {
    const isActive = this.renderPanelVisibility();
    this.applyBusy([this.passwordInput]);
    this.renderAuthStatus(this.statusEl);
    return isActive;
  }
}
